import { render, staticRenderFns } from "./DraftDiscussion.vue?vue&type=template&id=55630c00&scoped=true"
import script from "./DraftDiscussion.vue?vue&type=script&lang=ts"
export * from "./DraftDiscussion.vue?vue&type=script&lang=ts"
import style0 from "./DraftDiscussion.vue?vue&type=style&index=0&id=55630c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55630c00",
  null
  
)

export default component.exports